"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var VisuallyHidden_meta_1 = require("./VisuallyHidden.meta");

var VisuallyHidden =
/** @class */
function (_super) {
  __extends(VisuallyHidden, _super);

  function VisuallyHidden(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = VisuallyHidden_meta_1.VISUALLYHIDDEN_CATEGORY_KEY;
    _this.componentKey = VisuallyHidden_meta_1.VISUALLYHIDDEN_COMPONENT_KEY;
    return _this;
  }

  VisuallyHidden.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      style: {
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden'
      }
    }, children);
  };

  VisuallyHidden = __decorate([mobx_react_1.observer], VisuallyHidden);
  return VisuallyHidden;
}(shared_1.ComponentBase);

exports.VisuallyHidden = VisuallyHidden;
exports.default = shared_1.InjectedStyledComponent(VisuallyHidden, VisuallyHidden_meta_1.VISUALLYHIDDEN_CATEGORY_KEY, VisuallyHidden_meta_1.VISUALLYHIDDEN_COMPONENT_KEY);